<template>
  <section class="standby-filter">
    <sk-select :default-value="placeholder"
               :items-list="standbyOptions"
               class="standby__select"
               :preselected-value="standby"
               @csvaluechanged="onInputBoxChanged" />
  </section>
</template>

<script>
  export default {
    data() {
      return {
        standby: ''
      };
    },
    computed: {
      standbyOptions() {
        return [
          {id: '-1', name: this.$gettext('Clear')},
          {id: '1', name: this.$gettext('Can Standby')},
          {id: '0', name: this.$gettext('No Standby')}
        ];
      },
      placeholder() { return this.$gettext('Select a standby'); },
    },
    methods: {
      onInputBoxChanged(value) {
        this.standby = value;
        // reset filter value
        if (value == '-1') this.standby = '';
        else this.standby = value;

        this.params.parentFilterInstance((instance) => {
          instance.onFloatingFilterChanged('eq', value);
        });
      },

      onParentModelChanged(parentModel) {
        // When the filter is empty we will receive a null value here
        if (!parentModel) {
          this.standby = '';
        }
      }
    }
  };
</script>

<style>
.standby-filter .sk-select {
  background-color: #fff;
  font-weight: normal;
  font-size: 13px;
}

.standby-filter .sk-select__list {
  width: fit-content;
}

.standby-filter .sk-select__value {
  color: #333;
  font-weight: normal;
  font-size: 13px;
}

.standby-filter {
  width: 100%;
}
</style>
